<div class="container-fluid">
    <div class="form-position">
        <form [formGroup]="nextOfKinDetails" novalidate>

            
          <div class="card-body col-md-12">
              <div class="row">
                  <div class="col-md-6">
                      <mat-form-field appearance="standard">
                          <mat-label class="mat-label-margin">Name</mat-label>
                          <input matInput class="mat-textbox" input name="name" type="text" formControlName="name" autocomplete="nope"> 
                          <mat-error>
                              This field is required.
                          </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="col-md-6">
                      <mat-form-field appearance="standard">
                          <mat-label class="mat-label-margin">Surname</mat-label>
                          <input matInput class="mat-textbox" input name="surname" type="text" formControlName="surname" autocomplete="nope">
                          <mat-error>
                              This field is required.
                          </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="col-md-6">
                      <mat-form-field appearance="standard">
                          <mat-label class="mat-label-margin">Email</mat-label>
                          <input matInput class="mat-textbox" input name="email" type="text" formControlName="email" autocomplete="nope">
                          <mat-error>
                              Please enter a valid email address.
                          </mat-error>
                          <mat-icon matSuffix><i class="fa fa-envelope"></i></mat-icon>
                      </mat-form-field>
                  </div>
                  <div class="col-md-6">
                      <mat-form-field appearance="standard">
                          <mat-label class="mat-label-margin">Mobile Number</mat-label>
                          <input matInput class="mat-textbox" input name="mobile" type="text" formControlName="mobileNumber" autocomplete="nope">
                          <mat-error>
                              Please enter a valid mobile number.
                          </mat-error>
                          <mat-icon matSuffix><i class="fa fa-phone"></i></mat-icon>
                      </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="standard">
                      <mat-label class="mat-label-margin">Relationship</mat-label>

                      <mat-select formControlName="relationship">
                        <mat-option value="5">Spouse</mat-option>
                        <mat-option value="6">Parent</mat-option>
                        <mat-option value="7">Sibling</mat-option>
                        <mat-option value="8">Business Associate</mat-option>
                        <mat-option value="9">Other</mat-option>
                      </mat-select>

                      <mat-error>
                        Please select a valid relationship.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  
              </div>
          </div>
          <div class="row row-padding">
              <br>
              <button mat-fab class="form-button-right" style="box-shadow: none;" type="submit" (click)="save()" [disabled]="!nextOfKinDetails.valid"><i class="fa fa-arrow-right" ></i></button>
          </div>
        </form>
    </div>
</div>